import { createContext, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Rotulo, Selecao } from '../../componentes/formulario';
import { cabecalhoEmpresa } from '../api';
import { useSessao } from '../sessao';
import { empresaDaTela, precisaEmpresaNaTela } from './empresa-do-registro';

/**
 * Rodada rval1-1 (RVAL1-ROB-M2): a empresa de uma tela com a troca de empresa desligada (`precisaEmpresaNaTela`). `comTodas`
 * oferece "Minhas verticais" (valor vazio, sem empresa) para quem configura o que vale para todas; sem ela, a primeira
 * empresa já vem escolhida. `cabecalho` vai nas requisições da tela (`X-Empresa`), no lugar do filtro do topo.
 */
export function useEmpresaDaTela(opcoes: { comTodas?: boolean } = {}) {
  const s = useSessao();
  const mostra = precisaEmpresaNaTela(s.empresas);
  const [escolhida, setEscolhida] = useState(() => (mostra && !opcoes.comTodas ? (s.empresas?.opcoes[0]?.id ?? '') : ''));
  const empresa = empresaDaTela(s.empresas, escolhida);
  return { mostra, empresa, escolhida, setEscolhida, comTodas: !!opcoes.comTodas, cabecalho: mostra ? cabecalhoEmpresa(empresa) : {} };
}

/** O campo "Empresa" da tela (só aparece com `mostra`), com os componentes de sempre (`Rotulo` e `Selecao`). */
export function CampoEmpresaDaTela({ id, estado }: { id: string; estado: ReturnType<typeof useEmpresaDaTela> }) {
  const { t } = useTranslation();
  const s = useSessao();
  if (!estado.mostra) return null;
  return (
    <div className="min-w-0 sm:max-w-sm" data-empresa-da-tela="">
      <Rotulo id={id} rotulo={t('empresa.rotulo')} ajuda={t('empresa.ajudaTela')}>
        <Selecao
          id={id}
          aria-describedby={`${id}-ajuda`}
          value={estado.escolhida}
          onChange={(e) => estado.setEscolhida(e.target.value)}
          opcoes={[...(estado.comTodas ? [{ valor: '', rotulo: t('empresa.todas') }] : []), ...(s.empresas?.opcoes ?? []).map((o) => ({ valor: o.id, rotulo: o.nome }))]}
        />
      </Rotulo>
    </div>
  );
}

/** A empresa da tela para os componentes de dentro dela (cabeçalho vazio = vale o filtro do topo, como com a troca ligada). */
export const EmpresaDaTelaContexto = createContext<{ empresa: string | null; cabecalho: Record<string, string> }>({ empresa: null, cabecalho: {} });
export const useEmpresaDaTelaContexto = () => useContext(EmpresaDaTelaContexto);
